/* unplugin-vue-components disabled */import { render, staticRenderFns } from "./risC.vue?vue&type=template&id=06fd0d33&scoped=true"
import script from "./risC.vue?vue&type=script&lang=js"
export * from "./risC.vue?vue&type=script&lang=js"
import style0 from "./risC.vue?vue&type=style&index=0&id=06fd0d33&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06fd0d33",
  null
  
)

export default component.exports